// include PAST specific constants here

const VALID_TECHNOLOGIE_STATUSES = {
  clg0pzthz001e90hxh5dvbwq7: 'XGS-PON', // XGS-PON
  clgq8a5ws000wbkhx63nu40fm: 'GPON mit 2G Freigabe', // GPON + 2G
  clg0pzthy001d90hx7vwph3vc: 'GPON' // GPON
};

export {
  VALID_TECHNOLOGIE_STATUSES
}
